import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import { formatNumbers, newFormatPrice, showProgress } from '../../../../services/utilityFunctions';

function ProgressChartHalfMoon({ t, totalProgress, totalScoreTarget, totalUserPoints, unity, color, unityType, statsObj = {} }) {
  const checkCurrency = statsObj?.charts?.find(c => c.unity === 'currency');

  const per75 = totalProgress
    ? Math.round(totalProgress * 0.75)
    : 0;
  const infoUnity = unityType;

  const valueToUse = (type, number) => type === 'currency' ?
    newFormatPrice(number, false, checkCurrency?.currency || 'eur') : `${formatNumbers(number)} ${infoUnity}`;

  return (
    <div id="halfMoonProgress" className="best-day-container">
      <svg viewBox="0 0 40 20" className="best-day-graph">
        <path
          className="best-day-graph-background"
          strokeDasharray="75, 75"
          d="M6.7460 29.25395
              A 15.9155 15.9155 0 0 1 18 2.0845
              A 15.9155 15.9155 0 0 1 29.25395 29.25395"
        />
        <path
          className="best-day-graph-path"
          style={{ stroke: color }}
          strokeDasharray={`${per75}, 75`}
          d="M6.7460 29.25395
              A 15.9155 15.9155 0 0 1 18 2.0845
              A 15.9155 15.9155 0 0 1 29.25395 29.25395"
        />
      </svg>
      <br />
      {totalScoreTarget && totalUserPoints && (
        <div className="target-info-container">
          <div className="row">
            {totalScoreTarget &&
            <div className="info-target col-lg-12 col-12" style={{ color }}>
              {`${t('profile.performance.progress.target')}: ${valueToUse(unity, totalScoreTarget)}`}
            </div>
            }
          </div>
          <div className="row">
            {totalUserPoints &&
            <div className="info-score col-lg-12 col-12">
              {`${t('profile.performance.progress.reached')}: ${valueToUse(unity, totalUserPoints)}`}
            </div>
            }
          </div>
        </div>
      )}
      {!totalScoreTarget && !totalUserPoints && (
        <div className="best-day-points row">
          <span className="col-lg-12">{t('profile.performance.progress.completionRate')}</span>
          <span className="col-lg-12">{`${showProgress(totalProgress)} %`}</span>
        </div>
      )}
    </div>
  );
}

ProgressChartHalfMoon.propTypes = {
  t: PropTypes.func.isRequired,
  totalProgress: PropTypes.number,
  totalScoreTarget: PropTypes.number,
  totalUserPoints: PropTypes.number,
  unity: PropTypes.string,
  color: PropTypes.string.isRequired,
  unityType: PropTypes.string.isRequired,
  statsObj: PropTypes.shape({
    charts: PropTypes.arrayOf(PropTypes.shape({
      unity: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
};

ProgressChartHalfMoon.defaultProps = {
  totalProgress: 0,
  totalScoreTarget: null,
  totalUserPoints: null,
  unity: 'percentage',
};

export default translate(ProgressChartHalfMoon);
